module.exports = __webpack_public_path__ + "img/logo-minedu-2025-sm.202e73f7.png";